import BigNumber from 'bignumber.js';

export interface Position {
  size: BigNumber;
  notional: BigNumber;
}

export class Ledger {
  accountExpiries: { [account: string]: number[] } = {};
  accountStrikes: { [account: string]: { [expiry: number]: BigNumber[] } } = {};
  accountPositions: { [account: string]: { [expiry: number]: { [strike: string]: { [isCall: string]: Position } } } } = {};

  balances: { [key: string]: BigNumber } = {};
  positionsSnapshots: { [account: string]: any[] } = {};

  balanceOf(account: string) {
    return this.balances[account] || new BigNumber(0);
  }

  listOfExpiries(account: string) {
    return this.accountExpiries[account] || [];
  }

  listOfStrikes(account: string, expiry: number) {
    return this.accountStrikes[account]?.[expiry] || [];
  }

  positionSizeOf(account: string, expiry: number, strike: BigNumber, isCall: boolean) {
    return this.positionOf(account, expiry, strike, isCall).size;
  }

  positionOf(account: string, expiry: number, strike: BigNumber, isCall: boolean) {
    return this.accountPositions[account]?.[expiry]?.[strike.toString(10)]?.[isCall.toString()] || {
      size: new BigNumber(0),
      notional: new BigNumber(0)
    };
  }

  setPositions(account: string, positions: any[]) {
    this.positionsSnapshots[account] = positions;
    this.restorePositions(account);
  }

  restorePositions(account: string) {
    this.accountExpiries[account] = [];
    this.accountStrikes[account] = {};
    this.accountPositions[account] = {};
    (this.positionsSnapshots[account] || []).forEach((position: any) => {
      this.addPosition(
        account,
        position.expiry,
        position.strike.toDecimal(),
        position.isCall,
        position.size.toDecimal(),
        position.notional.toDecimal()
      );
    });
  }

  addPosition(account: string, expiry: number, strike: BigNumber, isCall: boolean, size: BigNumber, notional: BigNumber) {
    this.initStrike(account, expiry, strike);
    if (!this.accountPositions[account]) {
      this.accountPositions[account] = {};
    }
    if (!this.accountPositions[account][expiry]) {
      this.accountPositions[account][expiry] = {};
    }
    if (!this.accountPositions[account][expiry][strike.toString(10)]) {
      this.accountPositions[account][expiry][strike.toString(10)] = {};
    }
    this.accountPositions[account][expiry][strike.toString(10)][isCall.toString()] = {
      size, notional
    }
  }

  private initStrike(account: string, expiry: number, strike: BigNumber) {
    if (this.anyStrike(account, expiry)) {
      if (this.anyPosition(account, expiry, strike)) {
        return;
      } else {
        if (!this.accountStrikes[account][expiry]) {
          this.accountStrikes[account][expiry] = [];
        }
        this.accountStrikes[account][expiry].push(strike);
      }
    } else {
      if (!this.accountStrikes[account]) {
        this.accountStrikes[account] = {};
      }
      if (!this.accountStrikes[account][expiry]) {
        this.accountStrikes[account][expiry] = [];
      }
      this.accountStrikes[account][expiry].push(strike);
      if (!this.accountExpiries[account]) {
        this.accountExpiries[account] = [];
      }
      this.accountExpiries[account].push(expiry);
    }
  }

  // function clearStrike(address account, uint expiry, uint strike) internal {
  //   if (!anyPosition(account, expiry, strike)) {
  //     removeStrike(account, expiry, strike);
  //     if (!anyStrike(account, expiry))  {
  //       removeExpiry(account, expiry);
  //     }
  //   }
  // }

  // function removeStrike(address account, uint expiry, uint strike) internal {
  //   uint[] memory strikes = listOfStrikes(account, expiry);
  //   uint length = strikes.length;
  //   for (uint i = 0; i < length; i++) {
  //     if (strikes[i] == strike) {
  //       accountStrikes[account][expiry][i] = strikes[length - 1];
  //       accountStrikes[account][expiry].pop();
  //       return;
  //     }
  //   }
  //   revert('strike not found');
  // }

  // function removeExpiry(address account, uint expiry) internal {
  //   uint[] memory expiries = listOfExpiries(account);
  //   uint length = expiries.length;
  //   for (uint i = 0; i < length; i++) {
  //     if (expiries[i] == expiry) {
  //       accountExpiries[account][i] = expiries[length - 1];
  //       accountExpiries[account].pop();
  //       return;
  //     }
  //   }
  //   revert('expiry not found');
  // }

  private anyStrike(account: string, expiry: number) {
    return this.listOfStrikes(account, expiry).length > 0;
  }

  private anyPosition(account: string, expiry: number, strike: BigNumber) {
    return !this.positionSizeOf(account, expiry, strike, true).eq(0) || !this.positionSizeOf(account, expiry, strike, false).eq(0);
  }
}
